var map = {
	"./css3.svg": 64,
	"./express.svg": 65,
	"./figma.svg": 66,
	"./git.svg": 67,
	"./html5.svg": 68,
	"./illustrator.svg": 69,
	"./indesign.svg": 70,
	"./jquery.svg": 71,
	"./js.svg": 72,
	"./mongod.svg": 73,
	"./mongodb.svg": 74,
	"./nodejs.svg": 75,
	"./photoshop.svg": 76,
	"./react.svg": 77,
	"./redux.svg": 78,
	"./sass.svg": 79,
	"./vscode.svg": 80,
	"./webpack.svg": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;